/* Aura 20/10: ordem das opções dos filtros igual à da Matchday (o md-filtros.js dela faz isso no navegador).
   Range, Gender, Age, Season e Version seguem uma ordem fixa; Team e League (só o código na Shopify)
   ficam em ordem alfabética do nome, depois que o aura-club-labels põe os nomes.
   Só reordena quando a ordem muda, então não entra em ciclo com o observador. */
(function () {
  'use strict';
  var aplicando = false;
  var ORDEM_KIT = ['Home', 'Away', 'Third', 'Fourth', 'Fifth', 'Goalkeeper', 'Pre-Match', 'Training', 'Special', 'Retro'];
  var ORDEM_GENERO = ['Men', 'Women', 'Kids'];
  var ORDEM_IDADE = ['Adults', 'Kids'];
  var ORDEM_TEMPORADA = ['26/27', '25/26', '24/25', '23/24', '22/23', '21/22', 'Retro'];
  var ORDEM_VERSAO = ['Fan', 'Player Edition'];
  var LISTAS = [ORDEM_KIT, ORDEM_GENERO, ORDEM_IDADE, ORDEM_TEMPORADA, ORDEM_VERSAO];

  function textoDoItem(li) {
    var s = li.querySelector('[data-club]') || li.querySelector('.facet-checkbox__text-label');
    return ((s ? s.textContent : li.textContent) || '').replace(/​/g, '').replace(/^\s+|\s+$/g, '');
  }

  function ordemFixaDe(rotulos) {
    for (var i = 0; i < LISTAS.length; i++) {
      var ok = true;
      for (var j = 0; j < rotulos.length; j++) {
        if (LISTAS[i].indexOf(rotulos[j]) === -1) { ok = false; break; }
      }
      if (ok && rotulos.length > 1) return LISTAS[i];
    }
    return null;
  }

  function ordenarLista(ul) {
    var lis = Array.prototype.slice.call(ul.children);
    if (lis.length < 2) return;
    var rotulos = lis.map(textoDoItem);
    var fixa = ordemFixaDe(rotulos);
    var ordenados;
    if (fixa) {
      ordenados = lis.slice().sort(function (a, b) { return fixa.indexOf(textoDoItem(a)) - fixa.indexOf(textoDoItem(b)); });
    } else if (ul.querySelector('[data-club]')) {
      var spans = ul.querySelectorAll('[data-club]');
      for (var k = 0; k < spans.length; k++) if (spans[k].getAttribute('data-club-applied') !== '1') return;
      ordenados = lis.slice().sort(function (a, b) {
        var ta = textoDoItem(a).toLowerCase(), tb = textoDoItem(b).toLowerCase();
        return ta < tb ? -1 : ta > tb ? 1 : 0;
      });
    } else {
      return;
    }
    var mudou = false;
    for (var m = 0; m < ordenados.length; m++) if (ordenados[m] !== lis[m]) { mudou = true; break; }
    if (!mudou) return;
    aplicando = true;
    var pedaco = document.createDocumentFragment();
    for (var n = 0; n < ordenados.length; n++) pedaco.appendChild(ordenados[n]);
    ul.appendChild(pedaco);
    aplicando = false;
  }

  function passada() {
    if (aplicando) return;
    var listas = document.querySelectorAll('.facets__list, .facets__list--vertical, .mobile-facets__list');
    for (var i = 0; i < listas.length; i++) ordenarLista(listas[i]);
  }

  var agendado = false;
  function agendar() {
    if (agendado || aplicando) return;
    agendado = true;
    requestAnimationFrame(function () { agendado = false; passada(); });
  }

  if (window.MutationObserver) {
    new MutationObserver(agendar).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', passada);
  else passada();
  window.addEventListener('load', passada);
})();
